import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { WorksheetStatus } from '../../../interfaces/worksheet.model';

export interface WorksheetFilterDialogValue {
  dateFrom: Date | null;
  dateTo: Date | null;
  statuses: WorksheetStatus[];
}

export interface WorksheetFilterDialogData {
  value: WorksheetFilterDialogValue;
  statusOptions: { value: WorksheetStatus; label: string }[];
}

export type WorksheetFilterDialogResult =
  | { action: 'apply'; value: WorksheetFilterDialogValue }
  | { action: 'reset' };

@Component({
  providers: [provideTranslocoScope('receipts')],
  selector: 'rev-receipts-worksheet-filter-dialog-component',
  imports: [TranslocoPipe,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
  ],
  templateUrl: './receipts-worksheet-filter-dialog-component.html',
  styleUrl: './receipts-worksheet-filter-dialog-component.scss',
})
export class ReceiptsWorksheetFilterDialogComponent {
  private readonly dialogData = inject<WorksheetFilterDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<
    MatDialogRef<ReceiptsWorksheetFilterDialogComponent, WorksheetFilterDialogResult>
  >(MatDialogRef);

  readonly statusOptions = this.dialogData.statusOptions;
  dateFrom = this.dialogData.value.dateFrom;
  dateTo = this.dialogData.value.dateTo;
  selectedStatuses = [...this.dialogData.value.statuses];

  get dateRangeInvalid(): boolean {
    return !!this.dateFrom && !!this.dateTo && this.dateTo.getTime() < this.dateFrom.getTime();
  }

  close(): void {
    this.dialogRef.close();
  }

  reset(): void {
    this.dialogRef.close({ action: 'reset' });
  }

  apply(): void {
    if (this.dateRangeInvalid) {
      return;
    }

    this.dialogRef.close({
      action: 'apply',
      value: {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        statuses: this.selectedStatuses,
      },
    });
  }
}
